import {useEffect, useState} from "react";
import {iMileageEntry, iMileageReportData} from "../shared/interfaces";
import instance from "../api/instance";

interface iMileageHookOptions {
  allDeviceIds: string[];
  startDate: string;
  endDate: string;
  organizationKey: string;
  initialData: any;
  pageSize?: number;
}

export const useMileagePagination = ({
  allDeviceIds,
  startDate,
  endDate,
  organizationKey,
  initialData,
  pageSize = 3
}: iMileageHookOptions) => {
  const [data, setData] = useState<iMileageReportData[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setTotalPages(Math.ceil(allDeviceIds.length / pageSize));
  }, [allDeviceIds, pageSize, startDate, endDate]);

  const fetchPage = async (pageNum: number) => {
    if (pageNum === 1 && initialData && initialData.length > 0) {
      setData(initialData);
      return;
    }

    setLoading(true);

    const start = (pageNum - 1) * pageSize;
    const currentDeviceIds = allDeviceIds.slice(start, start + pageSize);

    if (currentDeviceIds.length === 0) {
      setData([]);
      setLoading(false);
      return;
    }

    const body = {
      organization_key: organizationKey,
      start_time: startDate,
      end_time: endDate,
      device_ids: currentDeviceIds
    };

    try {
      const {data} = await instance.post('/api/location/get-miles-per-state', body);
      setData(Object.values(data || {}));
    } catch (e) {
      console.error(e);
      setData([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchPage(currentPage);
  }, [currentPage]);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  return {
    data,
    loading,
    currentPage,
    totalPages,
    nextPage,
    prevPage,
    hasNext: currentPage < totalPages,
    hasPrev: currentPage > 1
  };
}
